module.exports = __webpack_public_path__ + "img/lead02.fa5acb45.png";